import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a bunk bed (0.9 x 2.0): two stacked berths, four corner posts,
// a small ladder at the +Z end and a guard rail on the upper berth.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const DUVET = "#f2efe8";
const PILLOW = "#e8e4dc";

export const bunkBed = defineModel({
  id: "bunk-bed",
  batchId: "modern",
  name: "Bunk bed",
  tags: ["modern", "interior", "furniture", "bedroom", "bed"],
  summary: "An oak bunk bed with two berths, a ladder and a guard rail.",
  tiles: { w: 1, h: 2 },
  footprint: 1.5,
  parts(): Part[] {
    return [
      // corner posts
      { geometry: new THREE.BoxGeometry(0.08, 1.85, 0.08), color: OAK, position: [-0.41, 0.925, -0.96] },
      { geometry: new THREE.BoxGeometry(0.08, 1.85, 0.08), color: OAK, position: [0.41, 0.925, -0.96] },
      { geometry: new THREE.BoxGeometry(0.08, 1.85, 0.08), color: OAK, position: [-0.41, 0.925, 0.96] },
      { geometry: new THREE.BoxGeometry(0.08, 1.85, 0.08), color: OAK, position: [0.41, 0.925, 0.96] },
      // lower berth
      { geometry: new THREE.BoxGeometry(0.9, 0.12, 2.0), color: OAK, position: [0, 0.31, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.14, 1.8), color: DUVET, position: [0, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.1, 0.3), color: PILLOW, position: [0, 0.56, -0.72] },
      // upper berth
      { geometry: new THREE.BoxGeometry(0.9, 0.12, 2.0), color: OAK, position: [0, 1.31, 0] },
      { geometry: new THREE.BoxGeometry(0.78, 0.14, 1.8), color: DUVET, position: [0, 1.44, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.1, 0.3), color: PILLOW, position: [0, 1.56, -0.72] },
      // guard rail on the upper berth (+X side)
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 1.5), color: OAK, position: [0.41, 1.72, 0] },
      // ladder at the +Z end — two stringers, three rungs
      { geometry: new THREE.BoxGeometry(0.05, 1.5, 0.05), color: WALNUT, position: [-0.16, 0.75, 1.0] },
      { geometry: new THREE.BoxGeometry(0.05, 1.5, 0.05), color: WALNUT, position: [0.16, 0.75, 1.0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.05, 0.05), color: WALNUT, position: [0, 0.5, 1.0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.05, 0.05), color: WALNUT, position: [0, 0.9, 1.0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.05, 0.05), color: WALNUT, position: [0, 1.3, 1.0] },
    ];
  },
  animations: [],
});
